export default __webpack_public_path__ + "static/media/Snd_TryS.a5aa7e15.mp3";